<template>
    <div class="patent-app__title" @mouseenter="showMore" @mouseleave="showLess">
        <div :class="['patent-app__title-content', { 'patent-app__title-content--active': isActive }]">
            <p v-if="showPlaceholder" class="patent-app__title-placeholder" />
            <template v-else>
                <div class="patent-app__title-container">
                    <span class="patent-app__title-pn" v-html="highlightMixin_hlText(patent.PN)" />
                    <Legal
                        v-if="!hideLegalStatus || isActive"
                        :legalObject="patent"
                        :legalStatus="legalStatusForDisplay"
                        :callbackParams="{ params: { patentId: patent.PATENT_ID } }"
                        :clickCallBack="onLegalIconClick"
                        :showText="isActive"
                        :openType="legalOpenInNew ? '_blank' : '_self'"
                        class="patent-app__title-legal"
                    >
                        <i :data-cas="`${patent.HAS_CAS}`" class="patent-app__title-cas-icon" />
                    </Legal>
                    <span v-if="!hideLegalStatus && hiddenLegalCount" class="patent-app__title-ellipsis">+{{ hiddenLegalCount }}</span>
                </div>
                <div class="patent-app__title-container">
                    <p v-if="!patent.Origin_TITLE" class="patent-app__title-context" v-html="$t('no-title')" />
                    <p v-else class="patent-app__title-context" v-html="highlightMixin_hlText(patent.Origin_TITLE)" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import higlightMixin from 'library-@/highlight/mixin';
import Legal from '@/components/legal';
import _ from 'lodash';
import litigationMf from '../subview_plugins/Litigation/manifest.js';
import licensingMf from '../subview_plugins/Licensing/manifest.js';
import abstMf from '../subview_plugins/Abst/manifest.js';

const legalDisplayLengthLimit = 4;

export default {
    name: 'InfoTitle',
    components: {
        Legal,
    },
    mixins: [higlightMixin],
    props: {
        patent: {
            type: Object,
            default: () => ({}),
        },
        showPlaceholder: {
            type: Boolean,
            default: false,
        },
        hideLegalStatus: {
            type: Boolean,
            default: false,
        },
        legalOpenInNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isActive: false,
            isHovering: false,
        };
    },
    computed: {
        legalStatusForDisplay() {
            const legalStatus = _.clone(_.get(this.patent, 'LEGAL_STATUS')) || [];
            return (legalStatus.length > legalDisplayLengthLimit && !this.isActive) ? legalStatus.splice(0, legalDisplayLengthLimit) : legalStatus;
        },
        hiddenLegalCount() {
            return _.get(this.patent, 'LEGAL_STATUS', []).length - this.legalStatusForDisplay.length;
        },
    },
    methods: {
        onLegalIconClick(key, param, event) {
            if (this.legalOpenInNew) return;
            event.preventDefault();
            if (key === 'LITIGATION') this.$router.push({ path: litigationMf.exclusiveRoutePath, query: this.$route.query, params: this.$route.params });
            if (key === 'LICENSE') this.$router.push({ path: licensingMf.exclusiveRoutePath, query: this.$route.query, params: this.$route.params });
            if (key === 'STANDARD') this.$router.push({ path: abstMf.exclusiveRoutePath, query: this.$route.query, params: this.$route.params });
        },
        showMore() {
            this.isHovering = true;
            setTimeout(() => {
                if (this.isHovering) this.isActive = true;
            }, 300);
        },
        showLess() {
            this.isHovering = false;
            this.isActive = false;
        },
    },
};
</script>

<style lang="scss">
@import "../assets/styles/var.scss";

.patent-app__title {
    letter-spacing: 0.44px;
    height: $titleHeight;
    overflow: visible;

    .patent-app__title-content {
        padding: 8px 6px 8px 8px;
        border-radius: 4px;
        border-bottom: 1px solid transparent;
    }
    .patent-app__title-content--active {
        white-space: normal;
        position: relative;
        z-index: 200;
        background: #fff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
        .patent-app__title-context {
            white-space: normal;
        }
    }

    .patent-app__title-pn {
        font-size: 14px;
        color: $text-green;
        line-height: 24px;
        margin-right: 8px;
        display: inline-block;
        vertical-align: middle;
    }

    .patent-app__title-legal {
        display: inline-block;
        .legal-tag {
            padding: 0 8px;
        }
        .legal-status__box {
            vertical-align: middle;
        }
        .patent-app__title-cas-icon {
            vertical-align: middle;
        }
    }

    .patent-app__title-ellipsis {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
        background-color: #ebecf0;
        color: #1976d2;
        line-height: 16px;
        padding: 2px 8px;
        border-radius: 2px;
        margin-left: 4px;
    }

    .patent-app__title-context {
        font-size: 14px;
        color: $neutral-blue-1000;
        text-align:left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 24px;
    }

    .patent-app__title-placeholder {
        height: 48px;
        background: rgba(158, 158, 158, .1);
    }
}
</style>
